import { backendSources } from "@/shared/api/firehose";
import { useSettingsStore } from "@/stores/SettingsStore";
import { useMutation } from "@tanstack/react-query";
import { setSourceColors } from "../api";
import toast from "react-hot-toast";

function FirehoseConfig() {
  const sourceColors = useSettingsStore((state) => state.sourceColors);

  const setSourceColor = useSettingsStore((state) => state.setSourceColor);

  const setSourceColorsMutation = useMutation({
    mutationFn: setSourceColors,

    onSuccess: () => toast.success("Source colors updated successfully."),

    onError: () =>
      toast.error("An error occurred while updating source colors."),
  });

  return (
    <div className="divide-y divide-white/10">
      <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <h2 className="text-base/7 font-semibold text-white">
            Firehose source colors
          </h2>
          <p className="mt-1 text-sm/6 text-gray-400">
            Set the color for each firehose source. This will be used to
            highlight the firehose list items in the app.
          </p>
        </div>
        <div className="">
          <form
            onSubmit={(e) => {
              e.preventDefault();

              setSourceColorsMutation.mutate(sourceColors);
            }}
          >
            {backendSources.map((source) => (
              <div
                key={source}
                className="flex items-center justify-between py-2"
              >
                <span className="capitalize text-gray-300">
                  {source.replace("-", " ")}
                </span>

                <input
                  type="color"
                  className=""
                  onChange={(e) => setSourceColor(source, e.target.value)}
                  value={sourceColors[source]}
                />
              </div>
            ))}
            <div className="flex justify-end py-8">
              <button
                type="submit"
                className="text-sm px-3 py-2 rounded-md border border-blue-600 bg-blue-900/20 text-blue-400 hover:border-blue-500 hover:text-blue-300 hover:bg-blue-900/30 transition-colors"
              >
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default FirehoseConfig;
